import React, { useState } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import InputField from "../InputField/InputField";
import * as Yup from "yup";
import * as AuthVerify from '../../lib/common';
import { Formik } from "formik";
import './ChangePassword.styles.css';
import { Flip, Slide, toast } from 'react-toastify';
import * as Axios from "../../services/auth";
import { useNavigate } from 'react-router-dom';

const CorporateformSchema = Yup.object().shape({
  // current_password: Yup.string().required("Current password is required"),
  new_password: Yup.string().required("New password is required"),
  confirm_password: Yup.string().oneOf([Yup.ref("new_password"), null], "Confirm your new password")
    .required("Confirm password is required"),
});

const ChangePassword = ({ token,email }) => {
  const navigate = useNavigate();

  const [initialValue, setInitialValue] = useState({
    // current_password: "",
    new_password: "",
    confirm_password: "",
  });
  
  const FormSubmitHandler = async (values) => {
    const url = "accounts/change-password"
    const val = {
      email:AuthVerify.getUser()?.email??email,
      password: values.new_password,
      confirmPassword: values.confirm_password
    }
    const response = await Axios.commonPost(val, url);
    if (response?.status === 200) {
      toast.success('Password Changed Successfully', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Slide,
      });
      navigate('/');
    }
    else {
      toast.error('Password not changed !', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Flip,
      })
    }
  }

  return (
    <>
      <section className="main-container col1-layout">
        <Container className="main">
          <Row className='justify-content-center'>
            <Col xs={12} sm={6} lg={12}>
              <div className="account-login">
                <div className="page-title mb-0">
                  <h2>Change Password</h2>
                </div>
                <Formik
                  initialValues={initialValue}
                  validationSchema={CorporateformSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    FormSubmitHandler(values);
                    setSubmitting(false);
                  }}
                  enableReinitialize
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="content">
                        <div className="form-list">
                          <Row>
                            <Col sm={6}>
                              {/* <div className='conform-password-input-main'>
                                <InputField
                                  ClassName="m-0"
                                  Name="current_password"
                                  id="current_password"
                                  Type="text"
                                  Placeholder="Current Password"
                                  value={values.email}
                                  onChange={handleChange}
                                  isInvalid={!!errors.current_password}
                                  className={(errors.current_password && touched.current_password) ? 'is-invalid' : 'form-control'}

                                />
                              </div> */}
                              <div className='conform-password-input-main'>
                                <InputField
                                  ClassName="m-0"
                                  Name="new_password"
                                  id="new_password"
                                  Type="text"
                                  Placeholder="New Password"
                                  value={values.new_password}
                                  onChange={handleChange}
                                  isInvalid={!!errors.new_password}
                                  className={(errors.new_password && touched.new_password) ? 'is-invalid' : 'form-control'}
                                />
                              </div>
                              <div className='conform-password-input-main'>
                                <InputField
                                  ClassName="m-0"
                                  Name="confirm_password"
                                  id="confirm_password"
                                  Type="text"
                                  Placeholder="Confirm Password"
                                  value={values.confirm_password}
                                  onChange={handleChange}
                                  isInvalid={!!errors.confirm_password}
                                  className={(errors.confirm_password && touched.confirm_password) ? 'is-invalid' : 'form-control'}
                                />
                              </div>
                              <button className="button" type='submit'>Update Password</button>
                            </Col>
                          </Row>
                        </div>
                      </div>

                    </form>
                  )}
                </Formik>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChangePassword;
